module.exports = __webpack_public_path__ + "img/形状 1125.ebfb5d76.png";